import { DomainObject } from "@/models/DomainObject";
import { StaffRole, CourseStaffRole, InvitationStatus } from '@/../types/enums';
import { TeamModel, CoachProfileModel } from "@/models";
import { fullName, isEmpty, isNotEmpty } from '@/pipes';

export interface StaffMember extends DomainObject {
	userId: string;
	coachId: string;
	email: string;
	firstName: string;
	lastName: string;
	pictureUrl?: string;
	role: StaffRole | CourseStaffRole;
	invitationStatus: InvitationStatus;
}

export function PopulateStaffMemberFromStaffMemberEx(staffMember: StaffMember, ex: StaffMemberEx) {
	staffMember.userId = ex.userId;
	staffMember.coachId = ex.coachId;
	staffMember.email = ex.email;
	staffMember.firstName = ex.firstName;
	staffMember.lastName = ex.lastName;
	staffMember.pictureUrl = ex.pictureUrl;
	staffMember.role = ex.role;
	staffMember.invitationStatus = ex.invitationStatus;
}

export class StaffMemberEx implements StaffMember {
	userId: string;
	coachId: string;
	email: string;
	firstName: string;
	lastName: string;
	pictureUrl?: string;
	role: StaffRole | CourseStaffRole;
	invitationStatus: InvitationStatus;
	coach: CoachProfileModel;
	match: CoachProfileModel;
	teams: Array<TeamModel>;
	teamRoles: Array<StaffRole | CourseStaffRole>;

	load<StaffMemberEx = this>(obj: Partial<StaffMemberEx>): this {
		Object.assign(this, obj);
		return this;
	}
	loadFromCoach(obj: Partial<CoachProfileModel>): this {
		if( isEmpty(obj) ) return this;

		this.coachId = obj.id;
		this.firstName = obj.firstName;
		this.lastName = obj.lastName;
		this.email = obj.email;
		this.pictureUrl = obj.pictureUrl;

		return this;
	}
	async loadTeams(orgTeams: Array<TeamModel> = []) {
		this.teams = [];
		this.teamRoles = [];
		for( const team of orgTeams ) {
			const coach = team.staffMembers.find(staff => staff.coachId === this.coachId)
			if( isNotEmpty(coach) ) {
				this.teams.push(team);
				this.teamRoles.push(coach.role);
			}
		}
	}

	get FullName(): string {
		if( this.coach ) return this.coach.FullName;
		return fullName(this.firstName, this.lastName);
	}
	get PictureUrl(): string {
		if( this.pictureUrl ) return this.pictureUrl;
		return this.coach?.pictureUrl;
	}
	get Email(): string {
		if( this.coach?.email ) return this.coach.email;
		return this.email;
	}
}